import { render } from "./OrderCancelled.vue?vue&type=template&id=e498ca86&scoped=true"
const script = {}

import "./OrderCancelled.vue?vue&type=style&index=0&id=e498ca86&scoped=true&lang=css"

import exportComponent from "/data03/virt76591/domeenid/www.kuulsaal.ee/bookings-frontend/git/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e498ca86"]])

export default __exports__